module.exports = __webpack_public_path__ + "media/noTemplateSelected.475d2797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noTemplateSelected.png
// module id = ./src/assets/noTemplateSelected.png
// module chunks = 0